<template>
  <div class="competition-preview-panel">
    <img
      v-if="currentImage"
      :src="currentImage"
      :alt="imageAlt"
      class="preview-image"
    />
    <div v-else class="preview-placeholder">
      <i class="fa-regular fa-image"></i>
      <span>Preview not available</span>
    </div>
  </div>
</template>

<script>
const PREVIEW_IMAGES = {
  light: {
    BasicsTab: 'https://hub.swiset.com/wp-content/uploads/2026/05/Helper-Image-Light-Competition-Basics.webp',
    PrizesTab: 'https://hub.swiset.com/wp-content/uploads/2026/05/Helper-Image-Light-Competition-Prizes.webp',
    RulesTab: 'https://hub.swiset.com/wp-content/uploads/2026/05/Helper-Image-Light-Competition-Rules.webp',
  },
  dark: {
    BasicsTab: 'https://hub.swiset.com/wp-content/uploads/2026/05/Helper-Image-Dark-Competition-Basics.webp',
    PrizesTab: 'https://hub.swiset.com/wp-content/uploads/2026/05/Helper-Image-Dark-Competition-Prizes.webp',
    RulesTab: 'https://hub.swiset.com/wp-content/uploads/2026/05/Helper-Image-Dark-Competition-Rules.webp',
  },
};

export default {
  name: "CompetitionPreviewPanel",
  props: {
    activeTab: {
      type: String,
      default: 'BasicsTab',
    },
  },
  computed: {
    isDarkTheme() {
      return Boolean(
        this.$vuetify &&
        this.$vuetify.theme &&
        this.$vuetify.theme.dark
      );
    },
    currentImage() {
      const theme = this.isDarkTheme ? 'dark' : 'light';
      const map = PREVIEW_IMAGES[theme];
      if (!map) return null;
      return map[this.activeTab] || null;
    },
    imageAlt() {
      const altMap = {
        'BasicsTab': 'Competition Basics Preview',
        'PrizesTab': 'Competition Prizes Preview',
        'RulesTab': 'Competition Rules Preview',
      };

      return altMap[this.activeTab] || 'Competition Preview';
    },
  },
};
</script>

<style lang="scss" scoped>
.competition-preview-panel {
  position: relative;
  width: 100%;
  border: 1px solid #9a9a9a;
  border-radius: 12px;
  overflow: hidden;
  background: transparent;
}

.preview-image {
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 12px;
}

.preview-placeholder {
  width: 100%;
  min-height: 640px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: var(--v-cardBackground-base);
  color: #9a9a9a;
  font-size: 14px;

  i {
    font-size: 48px;
    opacity: 0.5;
  }

  span {
    font-family: "Avenir", sans-serif;
    font-weight: 500;
  }
}

.theme--dark .competition-preview-panel {
  border-color: #424242;
}

.theme--dark .preview-placeholder {
  background: var(--v-cardBackground-base);
  color: rgba(255, 255, 255, 0.5);
}
</style>
